// src/pages/product/CompliancePage.js
import FeaturePageTemplate from './FeaturePageTemplate';

export default function CompliancePage() {
  return <FeaturePageTemplate slug="compliance" />;
}